import React from 'react'
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import Icon from '../Icon';
import { translate } from '../../Services/translation';

const SiblingProductStockIcon = ({ product, siblings }) => {

    const { size } = useTypedSelector(
        (state) => state.SelectedVariant
    );

    return (
        <>
            <div className='product-page__sibling-title'>{translate('product.color')}<span>{product.color}</span></div>
            <div className='product-page__sibling-container flex flex-row'>
                {siblings.map((sibling) => {

                    const variantPickerOption = sibling?.variantPickerOptions?.options?.find(
                        (o) => o.firstVariantValue.toLowerCase() === size?.toLowerCase()
                    );

                    //send last selected variant size in url to persist the size for the new sibling product
                    const selectedSize = size?.toLowerCase();
                    const urlWithSize = new URL(sibling.url, window.location.origin);
                    if (selectedSize) {
                        urlWithSize.searchParams.set("variantSize", selectedSize);
                    }

                    const isInStock = variantPickerOption
                    ? variantPickerOption?.stockStatus > 0
                    : sibling?.stockStatus.quantity > 0;

                    var iconName = isInStock ? "check-circle" : "cross-circle";

                    return (

                        <a
                            className={`product-page__sibling-item ${sibling.color?.toLowerCase() == product.color?.toLowerCase() ? "product-page__sibling-item-active" : ""}`}
                            href={urlWithSize.toString()}>
                            <Icon name={iconName} color='' className='product-page__sibling-item__stockIcon' />
                            {sibling.images && sibling.images.length > 0 ? (
                                <img
                                    className="product-page__sibling-item__content"
                                    src={sibling.asSiblingUrl}
                                    alt={sibling.images[0].alt || sibling.name}
                                />
                            ) : (
                                <p className="product-page__sibling-item__content">{sibling.color}</p>
                            )}
                        </a>
                    );
                })}
            </div>
        </>
    )
}

export default SiblingProductStockIcon;